<template>
    <h-container data-sticky-container>        
        <h-content />
    </h-container>
</template>

<script>
import Container from '@/components/Container'
import Content from '@/components/Content'

export default {
    name: 'app',
    components: {
        'h-container': Container,
        'h-content': Content
    }
}
</script>

<style lang="scss">
@import "~bootstrap";

body {
    background-image: linear-gradient(120deg, #fdfbfb 0%, #d4dfe4 100%);
    margin: 0;
    padding: 0;

    font-family: mr-eaves-sans,sans-serif !important;
    font-weight: 300 !important;
    font-style: normal;
}

@include media-breakpoint-up(lg) {
    body {
        background: url(assets/bgr.jpg) no-repeat center center fixed;
        background-size: cover;

        height: 100vh;
        overflow: hidden;
    }        
}

#app {

    font-family: mr-eaves-sans,sans-serif;
    font-weight: 300 !important;
    font-style: normal;
    
    //font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    text-shadow: 0px 2px 3px #fff;
}
</style>
